// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1_rFe","rootSmall":"AddTileButton_rootSmall__1bCIN"};